// 四个 Features 子页：场景化文案 + 独属主题色

function featurePage(config) {
  return {
    navPage: 'features',
    isGuide: true,
    guideTheme: config.guideTheme,
    guideBadge: config.badge,
    breadcrumbParent: { href: '/features/', label: 'Features' },
    breadcrumbLabel: config.breadcrumbLabel,
    title: config.title,
    intro: config.intro,
    scenarios: config.scenarios,
    heroMeta: config.heroMeta,
    heroIcon: config.heroIcon,
    bottomCta: config.bottomCta,
    sections: config.sections,
    relatedLinks: config.relatedLinks,
  };
}

export function createFeatureGuidePages(buildPageLinks) {
  return {
    '/features/hide-online/': featurePage({
      guideTheme: 'privacy',
      badge: 'Privacy Feature',
      breadcrumbLabel: 'Hide Online',
      heroIcon: require('@/assets/features/icon-hide-online.svg'),
      title: 'How to Hide Online Status in GB WhatsApp',
      intro: 'Tired of contacts seeing you online the moment you open a chat? GB WhatsApp lets you hide online status and last seen so you can read messages on your own schedule.',
      scenarios: [
        'Someone watches your “online” tag every time you open the app',
        'You want to reply later without looking rude or ignoring people',
        'You need more control over last seen and typing visibility',
      ],
      heroMeta: ['5 steps', 'Privacy control', 'Invisible browsing'],
      bottomCta: {
        title: 'Need GB WhatsApp first?',
        text: 'Install the latest APK, then open Privacy settings to hide online status and last seen.',
        button: 'Download GB WhatsApp APK',
        href: '/download/',
      },
      relatedLinks: buildPageLinks(['/features/anti-delete/', '/features/themes/', '/tutorials/install/', '/tutorials/']),
      sections: [
        {
          step: '01',
          scene: 'You open a chat and instantly show as online',
          heading: 'What hide online actually does',
          iconSrc: require('@/assets/features/icon-hide-online.svg'),
          body: [
            'Hiding online status stops others from seeing the green dot while you are inside the app. Last seen controls when people know you were active.',
          ],
          bullets: [
            'Online = visible while the app is open in the foreground',
            'Last seen = timestamp shown in chat info',
            'Typing indicator = separate setting you can also disable',
          ],
        },
        {
          step: '02',
          scene: 'You are in GB WhatsApp settings',
          heading: 'Turn off online status',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            {
              parts: [
                { text: 'GB WhatsApp', href: '/' },
                { text: ' adds extra privacy toggles beyond the official app.' },
              ],
            },
          ],
          bullets: [
            'Open GB WhatsApp → Settings → Privacy',
            'Find Hide online status or similar wording',
            'Choose who cannot see you online (Everyone / Contacts / Nobody)',
          ],
          tip: 'Wording may vary slightly by version — look under Privacy or GB Settings.',
        },
        {
          step: '03',
          scene: 'Contacts still see when you were last active',
          heading: 'Hide last seen from contacts',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'Combine hide online with last seen control for a calmer inbox experience.',
          ],
          bullets: [
            'Settings → Privacy → Last seen',
            'Set to Nobody or My contacts except… for selective visibility',
            'Review blue ticks and second tick options in the same menu',
          ],
        },
        {
          step: '04',
          scene: 'You hid status but someone still knows you are there',
          heading: 'Who can still see you',
          iconSrc: require('@/assets/features/icon-hide-online.svg'),
          body: [
            'Privacy mods reduce visibility — they do not make you invisible in every situation.',
          ],
          bullets: [
            'Active replies still show you are available once you send a message',
            'Group chats may expose activity through read receipts',
            'Calls and status views follow separate permission rules',
          ],
          avoid: [
            'Assuming hide online blocks message delivery notifications on your phone',
            'Expecting official WhatsApp contacts to lose all visibility instantly',
          ],
        },
        {
          step: '05',
          scene: 'You want daily-use privacy without drama',
          heading: 'Practical privacy benefits',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          body: [
            'Used normally, these settings help you batch replies and reduce pressure to answer immediately.',
          ],
          bullets: [
            'Read urgent messages first without broadcasting activity',
            'Pair with DND when you need focus time',
            'Combine with custom themes or chat lock for layered control',
          ],
        },
      ],
    }),

    '/features/anti-delete/': featurePage({
      guideTheme: 'anti-delete',
      badge: 'Anti Delete Feature',
      breadcrumbLabel: 'Anti Delete',
      heroIcon: require('@/assets/features/icon-anti-delete.svg'),
      title: 'How to Read Deleted Messages in GB WhatsApp (Anti Delete Feature)',
      intro: 'Someone deleted a message after you saw the notification? Anti delete keeps a local copy so you can read removed texts and status updates before they disappear.',
      scenarios: [
        'A contact deletes a message right after sending it',
        'You saw a status vanish before you finished reading',
        'You need context from a removed group message',
      ],
      heroMeta: ['5 steps', 'Recover deleted text', 'Status viewer'],
      bottomCta: {
        title: 'Using anti delete responsibly',
        text: 'Enable the feature after installing GB WhatsApp, and avoid risky usage patterns that trigger account warnings.',
        button: 'Read ban prevention guide',
        href: '/tutorials/ban/',
      },
      relatedLinks: buildPageLinks(['/features/hide-online/', '/features/themes/', '/tutorials/install/', '/tutorials/ban/']),
      sections: [
        {
          step: '01',
          scene: 'You only see “This message was deleted”',
          heading: 'What anti delete does',
          iconSrc: require('@/assets/features/icon-anti-delete.svg'),
          body: [
            'When enabled, GB WhatsApp saves incoming content locally before the sender revokes it.',
          ],
          bullets: [
            'Works on one-to-one and many group messages',
            'Can also surface deleted status media in some builds',
            'Does not recover messages deleted before you received them',
          ],
        },
        {
          step: '02',
          scene: 'You want the feature active before the next message',
          heading: 'Enable anti revoke in settings',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            'Turn the option on once — new deleted messages are captured after that point.',
          ],
          bullets: [
            'Open GB Settings → Privacy or Universal',
            'Enable Anti-revoke / Anti-delete messages',
            'Restart the app if the toggle does not apply immediately',
          ],
          tip: 'Update to the latest APK if the menu item is missing on older builds.',
        },
        {
          step: '03',
          scene: 'A deleted message just arrived',
          heading: 'Read deleted chat messages',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          body: [
            'Open the conversation — anti delete usually shows the original text with a small indicator.',
          ],
          bullets: [
            'Scroll to the message bubble that was removed on the sender side',
            'Media may still appear if it was downloaded before deletion',
            'Screenshot if you need a record outside the app',
          ],
        },
        {
          step: '04',
          scene: 'Someone removed a status you wanted to see',
          heading: 'View deleted status updates',
          iconSrc: require('@/assets/features/icon-anti-delete.svg'),
          body: [
            'Status anti delete works similarly — content is cached when you open the status tab.',
          ],
          bullets: [
            'Open Status before it expires when possible',
            'Check GB Settings for status-specific anti delete options',
            'Stories deleted before you viewed them cannot be reconstructed',
          ],
        },
        {
          step: '05',
          scene: 'You are weighing convenience vs etiquette',
          heading: 'Privacy and limitations',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'Anti delete is powerful — use it for legitimate personal needs, not to harass others.',
          ],
          bullets: [
            'Senders still believe their delete action worked on their device',
            'Backups may store deleted content — secure your phone',
            'Does not bypass end-to-end expectations for all message types',
          ],
          avoid: [
            'Confronting people solely because you recovered deleted text',
            'Sharing recovered private messages without consent',
          ],
        },
      ],
    }),

    '/features/themes/': featurePage({
      guideTheme: 'themes',
      badge: 'Customization',
      breadcrumbLabel: 'Custom Themes',
      heroIcon: require('@/assets/features/icon-themes.svg'),
      title: 'How to Customize Themes in GB WhatsApp',
      intro: 'Bored of the default green interface? GB WhatsApp themes let you change chat colors, fonts, and the overall look without touching official WhatsApp.',
      scenarios: [
        'You want a dark or AMOLED style for night chatting',
        'Your chat wallpaper and bubble colors feel outdated',
        'You downloaded a .xml theme and need to apply it',
      ],
      heroMeta: ['5 steps', 'UI makeover', 'Fonts & colors'],
      bottomCta: {
        title: 'Ready to personalize?',
        text: 'Install GB WhatsApp, then browse built-in themes or import one from a trusted source.',
        button: 'Download latest APK',
        href: '/download/',
      },
      relatedLinks: buildPageLinks(['/features/hide-online/', '/features/dual-whatsapp/']),
      sections: [
        {
          step: '01',
          scene: 'You want the app to look different instantly',
          heading: 'What GB WhatsApp themes include',
          iconSrc: require('@/assets/features/icon-themes.svg'),
          body: [
            'Themes can change the header, chat bubbles, icons, fonts, and accent colors in one package.',
          ],
          bullets: [
            'Built-in presets ship with the APK',
            'Community themes often use .xml packages',
            'Some builds also allow per-chat wallpaper overrides',
          ],
        },
        {
          step: '02',
          scene: 'You are browsing inside the app',
          heading: 'Switch themes in settings',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            'The fastest way to test a new look is through the theme gallery.',
          ],
          bullets: [
            'Open GB Settings → Themes',
            'Preview a theme before applying',
            'Tap Download or Apply and wait for the UI to refresh',
          ],
          tip: 'If colors look wrong after apply, restart GB WhatsApp once.',
        },
        {
          step: '03',
          scene: 'You found a theme file online',
          heading: 'Download and apply external themes',
          iconSrc: require('@/assets/install/step-01-download.svg'),
          body: [
            'Only import theme files from sources you trust — bad packages can break the UI or harm stability.',
          ],
          bullets: [
            'Save the .xml file to Downloads',
            'In Themes → Import or Load theme, select the file',
            'Revert to default if icons or text become unreadable',
          ],
        },
        {
          step: '04',
          scene: 'You want chats to feel more personal',
          heading: 'Customize chat appearance',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          body: [
            'Fine-tune bubbles and backgrounds without a full theme swap.',
          ],
          bullets: [
            'Settings → Universal → Colors or Chat settings',
            'Set custom wallpaper per chat or globally',
            'Adjust outgoing vs incoming bubble colors separately on some builds',
          ],
        },
        {
          step: '05',
          scene: 'Text feels too small or too plain',
          heading: 'Font and UI personalization',
          iconSrc: require('@/assets/features/icon-themes.svg'),
          body: [
            'Font packs and scaling options help readability on large or compact phones.',
          ],
          bullets: [
            'Look for Font style under GB Settings',
            'Increase chat font size if you read long messages daily',
            'Pair bold fonts with high-contrast bubble colors for accessibility',
          ],
        },
      ],
    }),

    '/features/dual-whatsapp/': featurePage({
      guideTheme: 'dual',
      badge: 'Dual Account',
      breadcrumbLabel: 'Dual WhatsApp',
      heroIcon: require('@/assets/features/icon-dual.svg'),
      title: 'How to Use Dual WhatsApp on One Phone (GB WhatsApp)',
      intro: 'Need work and personal WhatsApp on one Android phone? GB WhatsApp can run as a second account alongside official WhatsApp — each with its own number and chat history.',
      scenarios: [
        'You carry one phone but have two SIM numbers',
        'You want a business line separate from family chats',
        'Official WhatsApp dual-app clone feels limited on your device',
      ],
      heroMeta: ['5 steps', 'Two numbers', 'Same device'],
      bottomCta: {
        title: 'Setting up your second account?',
        text: 'Install GB WhatsApp first, verify the second number, then switch between apps from your home screen.',
        button: 'View install guide',
        href: '/tutorials/install/',
      },
      relatedLinks: buildPageLinks(['/features/themes/', '/features/hide-online/']),
      sections: [
        {
          step: '01',
          scene: 'You wonder if two WhatsApps can coexist',
          heading: 'What dual WhatsApp means here',
          iconSrc: require('@/assets/features/icon-dual.svg'),
          body: [
            'GB WhatsApp uses a different package name, so it can install beside official WhatsApp instead of replacing it.',
          ],
          bullets: [
            'Official WhatsApp keeps your first number',
            'GB WhatsApp handles the second number',
            'Each app has separate chats, media, and backups',
          ],
        },
        {
          step: '02',
          scene: 'You have two active SIM cards',
          heading: 'How GB WhatsApp enables two accounts',
          iconSrc: require('@/assets/install/step-04-android.svg'),
          body: [
            'Android treats them as two apps — notifications, icons, and permissions are independent.',
          ],
          bullets: [
            'Confirm both SIMs receive SMS for verification',
            'Label home-screen icons (Work / Personal) to avoid opening the wrong app',
            'Some brands also offer system “Dual apps” — you usually do not need both',
          ],
        },
        {
          step: '03',
          scene: 'You are setting up the second line',
          heading: 'Set up dual WhatsApp on one phone',
          iconSrc: require('@/assets/tutorials/icon-install.svg'),
          body: [
            'Install GB WhatsApp, verify the second number, and keep official WhatsApp logged into the first.',
          ],
          bullets: [
            'Install GB WhatsApp APK without uninstalling official WhatsApp',
            'Verify the secondary phone number inside GB WhatsApp',
            'Restore backup only for the number you are setting up in that app',
          ],
          tip: 'Never use the same number in both apps at once — pick one app per number.',
        },
        {
          step: '04',
          scene: 'You jump between work and personal chats all day',
          heading: 'Switch accounts easily',
          iconSrc: require('@/assets/tutorials/icon-transfer.svg'),
          body: [
            'Switching is as simple as opening the other app from your launcher or recent apps.',
          ],
          bullets: [
            'Pin both icons to the home screen dock',
            'Use different notification sounds per app if your launcher allows it',
            'Back up each account separately before major updates',
          ],
        },
        {
          step: '05',
          scene: 'Something feels unstable with two accounts',
          heading: 'Limitations and tips',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'Dual setup is convenient but doubles storage use and update responsibility.',
          ],
          bullets: [
            'Keep both apps updated from trusted APK sources',
            'Monitor storage — two accounts mean two media folders',
            'Use ban-prevention habits on both numbers if you message heavily',
          ],
          avoid: [
            'Logging the same number into both apps repeatedly',
            'Ignoring backup before updating either installation',
          ],
        },
      ],
    }),
  };
}
